<section class="docusign-return">
  <ng-container *ngIf="waiting">
    <!--
      An INLINE spinner, deliberately not ifp-spinner-loading. That component is the whole-page
      blocker — `position: fixed; inset: 0; background: black; opacity: .75; z-index: 10000000` —
      so using it here painted the viewport black and buried the very copy it was meant to
      accompany. mat-spinner reaches this template through common's MaterialModule.
    -->
    <mat-spinner class="docusign-return__spinner"
                 diameter="45"></mat-spinner>
    <h2 class="docusign-return__title">Confirming your signature</h2>
    <p class="docusign-return__body">This takes a few seconds. Please don't close this page.</p>
  </ng-container>

  <ng-container *ngIf="finalising">
    <h2 class="docusign-return__title">We're finalising your agreement</h2>
    <p class="docusign-return__body">
      Your signature has been collected. It can take a moment to appear on your account — you don't
      need to sign again.
    </p>
    <button mat-flat-button
            color="primary"
            (click)="goToDashboard()">Go to dashboard</button>
  </ng-container>

  <ng-container *ngIf="awaitingCoSigners">
    <h2 class="docusign-return__title">Thanks — your signature is in</h2>
    <p class="docusign-return__body">
      The agreement is executed once everyone has signed. We'll email you as soon as it is, and your
      account opens then.
    </p>
    <p class="docusign-return__body"
       *ngIf="outstandingSignerNames.length">
      Still to sign:
      <span *ngFor="let name of outstandingSignerNames; trackBy: trackByName">{{ name }} </span>
    </p>
    <button mat-flat-button
            color="primary"
            (click)="goToDashboard()">Go to dashboard</button>
  </ng-container>

  <ng-container *ngIf="declined">
    <h2 class="docusign-return__title">Agreement declined</h2>
    <p class="docusign-return__body">
      You chose not to sign this agreement, so it has not been executed. Please contact your business
      advisor if you would like to continue.
    </p>
    <button mat-flat-button
            color="primary"
            (click)="goToDashboard()">Go to dashboard</button>
  </ng-container>
</section>
